import { CatalogTableRow } from '@agilelab/plugin-wb-builder-catalog';
import { TableProps } from '@backstage/core-components';
import { Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Entity } from '@backstage/catalog-model';

export type ServiceAccountActionsProps = {
  allowed: boolean;
  onEdit: (entity: Entity) => void;
  onDelete: (entity: Entity) => void;
};

export function useServiceAccountActions({
  allowed,
  onEdit,
  onDelete,
}: ServiceAccountActionsProps): TableProps<CatalogTableRow>['actions'] {
  if (!allowed) {
    return [];
  }

  const actions: TableProps<CatalogTableRow>['actions'] = [
    ({ entity }) => {
      const title = 'Edit';
      return {
        icon: () => (
          <>
            <Typography variant="srOnly">{title}</Typography>
            <EditIcon fontSize="small" />
          </>
        ),
        tooltip: title,
        onClick: () => {
          onEdit(entity);
        },
      };
    },
    ({ entity }) => {
      const title = 'Delete';
      return {
        icon: () => (
          <>
            <Typography variant="srOnly">{title}</Typography>
            <DeleteIcon fontSize="small" />
          </>
        ),
        tooltip: title,
        onClick: () => {
          onDelete(entity);
        },
      };
    },
  ];

  return actions;
}

export const ServiceAccountActionsColumn = useServiceAccountActions;
